import React from "react";
import { contactEmail, rrss, footerMenu } from "../data/links";
import footerLogo from "../assets/img/footer-logo.png";

export default function Footer() {
  return (
    <div id="footer">
      <div className="footer-logo">
        <img className="footer-img" alt="logo" src={footerLogo} />
      </div>
      <footer id="footer-wrapper">
        <div className="footer-contact">{contactEmail}</div>

        <div className="footer-rrss">
          <a
            className="social-icon x"
            title="X"
            href={rrss.x}
            target="_blank"
            rel="noopener noreferrer"
          />
          <a
            className="social-icon ig"
            title="Instagram"
            href={rrss.ig}
            target="_blank"
            rel="noopener noreferrer"
          />
          <a
            className="social-icon dc"
            title="Discord"
            href={rrss.dc}
            target="_blank"
            rel="noopener noreferrer"
          />
          <a
            className="social-icon pp"
            title="Pinterest"
            href={rrss.pp}
            target="_blank"
            rel="noopener noreferrer"
          />
          <a
            className="social-icon kf"
            title="Ko-fi"
            href={rrss.kf}
            target="_blank"
            rel="noopener noreferrer"
          />
        </div>

        <div className="footer-menu">
          {footerMenu.map((item, index) => (
            <a key={index} className="nav-link" href={item.path}>
              {item.label}
            </a>
          ))}
        </div>
      </footer>
    </div>
  );
}
